import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

let _token = null;
export function setToken(t) {
  _token = t;
  if (t) {
    api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
    localStorage.setItem("mc_token", t);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem("mc_token");
  }
}

export function getToken() {
  if (_token) return _token;
  const t = localStorage.getItem("mc_token");
  if (t) _token = t;
  return _token;
}

// bootstrap on import
const boot = getToken();
if (boot) api.defaults.headers.common["Authorization"] = `Bearer ${boot}`;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
